import { getCDNUrl, setCDNUrl } from "react-sounds";
import lockSound from "@/shared/sounds/ios-lock.mp3";
import swipeSound from "@/shared/sounds/lock.mp3";
import enterGameSound from "@/shared/sounds/r_music_enter_game.mp3";
import openModalSound from "@/shared/sounds/r_music_open_menu.mp3";
import buttonClickSound from "@/shared/sounds/r_vfx_button_select.mp3";
import systemNotificationSound from "@/shared/sounds/r_vfx_notification_system.mp3";

setCDNUrl("https://cdn.region.game/cef/sounds/");
const accontBackgroundSound = `${getCDNUrl()}region_music_charchoice&create_menu%20(1)%20(mp3cut.net).mp3`;

export enum Soundtrack {
  DefaultClick,
  AccountBackground,
  OpenModal,
  EnterGame,
  Lock,
  Swipe,
  SystemNotification,
}

const soundtrackDict: Record<Soundtrack, string> = {
  [Soundtrack.DefaultClick]: buttonClickSound,
  [Soundtrack.AccountBackground]: accontBackgroundSound,
  [Soundtrack.OpenModal]: openModalSound,
  [Soundtrack.EnterGame]: enterGameSound,
  [Soundtrack.Lock]: lockSound,
  [Soundtrack.Swipe]: swipeSound,
  [Soundtrack.SystemNotification]: systemNotificationSound,
};

export default soundtrackDict;
